<template>
  <div class="tab tab-skills">
    <v-select id="skill" name="skill" label="name" v-model="state.selectedSkill" :options="skills_evaluated" :reduce="(skill) => {
      if (currentCampaign.version === 1) return skill.id;
      else return skill.id_v2 ?? skill.id;
    }
      " :clearable="false">
      <template #option="{ name }">
        <span>{{ name }}</span>
      </template>
    </v-select>
    <div v-if="currentSkill" class="panel-block">
      <div v-if="currentSkill.id !== 'learn_strategy' && currentSkill.id !== 'leadership'" class="block">
        <h4>Résultat sur la compétence</h4>
        <div class="resume">
          <span class="skill-notation" :class="currentCandidate.results[getModuleId(currentSkill)].rank"
            v-text="currentCandidate.results[getModuleId(currentSkill)].rank" />
          <p v-text="getWording(
            `campaign.results.appreciations['${currentCandidate.results[getModuleId(currentSkill)].rank
            }']`
          )
            " />
        </div>
        <div v-if="
          currentCandidate.results.social_desire_score?.score > 75 &&
          [
            'empathy_score',
            'active_listen_score',
            'auto_efficient_score',
          ].includes(getModuleId(currentSkill))
        " v-tooltip="'Les questionnaires indiquent une forte tendance à la désirabilité sociale chez ce talent. Cette inclinaison peut refléter une volonté de mettre en avant une image positive de soi, ce qui peut influencer certaines réponses. Afin d’obtenir une évaluation plus complète et nuancée de ces compétences, il peut être pertinent de croiser ces résultats avec d’autres méthodes d’évaluation.'
          ">
          <i class="bi-info-circle" style="color: #f2cb36" />
          <span style="margin-left: 8px; font-size: 14px">Tendance à la désirabilité sociale détectée sur cette
            compétence</span>
        </div>
      </div>
      <template v-if="currentSkill.type === 'style'">
        <div class="block">
          <h4>Profil du talent</h4>
          <div class="block-result">
            <Tag class="yellow bold" :text="getResultWording(currentSkill, 'label')" />
            <p>{{ getResultWording(currentSkill, "analysis") }}</p>
          </div>
          <div class="block-position" v-if="currentSkill.id !== 'leadership'">
            <div v-for="(item, index) in Object.entries(
              currentSkill.result_wordings
            ).reduce((acc, [id, value]) => {
              value.label ? acc.push(value?.label) : null;
              return acc;
            }, [])" :key="index" class="item" :class="{
              selected: item === getResultWording(currentSkill, 'label'),
            }">
              {{ item }}
            </div>
          </div>
          <div v-else>
            <Bar :data="leadershipGraphData" :options="leadershipGraphOptions" v-if="!leadershipAllZeros" />
            <div class="leadership-adaptability" v-if="leadershipAdaptable">
              <div class="adapt-title">
                <i class="bi-info-circle" style="color: #f2cb36" />
                Talent adaptable
              </div>
              <span>L’évaluation du leadership du talent révèle une proximité
                entre plusieurs styles majoritaires parmi les trois analysés. Cela suggère une <b>flexibilité dans son
                  approche
                  du leadership</b> en fonction du contexte socio-organisationnel.</span>
            </div>
          </div>
        </div>
        <div class="block" v-if="getResultWording(currentSkill, 'analysis_communication')">
          <h4>Implications en terme de communication</h4>
          <p>{{ getResultWording(currentSkill, 'analysis_communication') }}</p>
        </div>
        <div class="block" v-if="getResultWording(currentSkill, 'analysis_teamwork')">
          <h4>Implications en terme de travail en équipe</h4>
          <p>{{ getResultWording(currentSkill, 'analysis_teamwork') }}</p>
        </div>
        <div class="block">
          <h4>Les avantages</h4>
          <p v-if="typeof getResultWording(currentSkill, 'plus') === 'string'">{{ getResultWording(currentSkill, "plus")
          }}</p>
          <div v-for="plus in getResultWording(currentSkill, 'plus')" :key="plus" class="avantage" v-else>
            <div class="icon-container">
              <i class="yuzu-icon" :class="plus.icon" />
            </div>
            <p v-html="plus.text" />
          </div>
        </div>
        <div class="block">
          <h4>les inconvénients</h4>
          <p v-if="typeof getResultWording(currentSkill, 'minus') === 'string'">{{ getResultWording(currentSkill,
            "minus") }}</p>
          <div v-for="minus in getResultWording(currentSkill, 'minus')" :key="minus" class="avantage" v-else>
            <div class="icon-container">
              <i class="yuzu-icon" :class="minus.icon" />
            </div>
            <p v-html="minus.text" />
          </div>
        </div>
      </template>
      <div class="block" v-if="currentSkill.id !== 'learn_strategy' && currentSkill.id !== 'leadership'">
        <h4>NOTRE ANALYSE</h4>
        <p v-text="getResultWording(currentSkill, 'analysis')" />
      </div>
      <div class="block" v-if="getResultWording(currentSkill, 'advices')">
        <h4>NOS CONSEILS</h4>
        <p v-text="getResultWording(currentSkill, 'advices')" />
      </div>
      <Button class="secondary outline icon sm" label="Plus d'informations"
        :icon="`bi-chevron-${state.extraOpen ? 'up' : 'down'}`" @click="state.extraOpen = !state.extraOpen" />
      <transition name="fade">
        <div v-if="state.extraOpen" class="extra-info">
          <div class="block">
            <h4 class="no-margin-top">Définition</h4>
            <p v-html="currentSkill.result_wordings.skill_description" />
          </div>
          <div class="block">
            <h4>Son importance</h4>
            <div v-for="advantage in currentSkill.result_wordings.advantages" :key="advantage" class="avantage">
              <div class="icon-container">
                <i class="yuzu-icon" :class="advantage.icon" />
              </div>
              <p v-html="advantage.text" />
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.leadership-adaptability {
  margin-top: 32px;

  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;

  border-radius: 6px;
  border: 1px solid #F2CB36;

  font-size: 15px;

  .adapt-title {
    font-weight: 700;
  }
}
</style>

<script setup lang="ts">
import { reactive, computed } from "vue";
import { useDark } from "@vueuse/core";
import { storeToRefs } from "pinia";

import { useModulesStore } from "@/stores/modules.js";
import { useCampaignStore } from "@/stores/campaign.js";
import { getWording } from "@/composables/utils.js";
import Bar from "@/components/charts/Bar.vue";

import type { LeadershipStyle } from "@/views/game/resultV2/leadership_style"

const modulesStore = useModulesStore();

const campaignStore = useCampaignStore();

const { modules } = storeToRefs(modulesStore);

const { currentCampaign } = storeToRefs(campaignStore);

const props = defineProps({
  currentCandidate: {
    type: Object,
    required: true,
  },
});

const skills_evaluated = computed(() => {
  if (!props.currentCandidate.results) return [];

  return modules.value.filter((elt) => {
    if (currentCampaign.value.version === 1) {
      return Object.keys(props.currentCandidate.results).includes(elt.id);
    }

    if (elt.disabled) return false;

    const currentCandidateResults = props.currentCandidate.results[getModuleId(elt)];
    const hasValue = currentCandidateResults.value || currentCandidateResults.rank;
    if (!hasValue) return false;

    if (elt.id === "leadership") return campaignStore.isV2_1(campaignStore.currentCampaign);
    if (elt.id === "planning") return campaignStore.isV2_1(campaignStore.currentCampaign);

    return true;
  });
});

const state = reactive({
  extraOpen: false,
  selectedSkill: skills_evaluated.value[0]?.id_v2 ?? skills_evaluated.value[0]?.id,
});

const currentSkill = computed(() => {
  return skills_evaluated.value.find(
    (skill) =>
      skill.id_v2 === state.selectedSkill || skill.id === state.selectedSkill
  );
});

function getModuleId(module) {
  if (currentCampaign.value.version === 1) return module.id;

  return `${module.id_v2 ?? module.id}_${module.type === "skill" ? "score" : "style"}`;
}

function getResultWording(skill, id) {
  if (!skill.result_wordings) return null;

  let rank = props.currentCandidate.results[getModuleId(skill)].rank;

  if (skill.type === "style") {
    let value = props.currentCandidate.results[getModuleId(skill)].value;

    if (skill.id === "leadership") {
      const candidateStyles: LeadershipStyle = JSON.parse(props.currentCandidate.results.leadership_style.value);
      value = candidateStyles.leading_style;
    }

    rank = Object.entries(skill.result_wordings).find(
      ([, obj]) =>
        obj.id === value
    )[0];
  }

  return skill.result_wordings[rank][id];
}

const isDark = useDark();

const leadershipGraphData = computed(() => {
  const candidateStyles: LeadershipStyle = JSON.parse(props.currentCandidate.results.leadership_style.value);
  // sort the categories by value
  candidateStyles.categories = Object.fromEntries(
    Object.entries(candidateStyles.categories).sort(([, a], [, b]) => b - a)
  );
  const dominantStyle = candidateStyles.leading_style;

  const primaryColor = "#FFCA00";
  const secondaryColor = isDark.value ? "#FFFFFF" : "#000000";

  return {
    labels: Object.keys(candidateStyles.categories).map((key) => {
      return modules.value.find((module) => module.id === "leadership").result_wordings[key].label;
    }),
    datasets: [
      {
        backgroundColor: Object.entries(candidateStyles.categories).map(([key, value]) => {
          if (key === dominantStyle) return primaryColor;
          return secondaryColor;
        }),
        data: Object.values(candidateStyles.categories),
      },
    ],
  };
});

const leadershipGraphOptions: ChartOptions = {
  indexAxis: 'y',
  scales: {
    x: {
      max: 100,
      ticks: {
        callback: function (value, index, ticks) {
          return value + "%";
        }
      }
    }
  }
}

const leadershipAdaptable = computed(() => {
  if (!props.currentCandidate.results) return null;

  const candidateStyles: LeadershipStyle = JSON.parse(props.currentCandidate.results.leadership_style.value);
  return candidateStyles.adaptability_badge;
});

const leadershipAllZeros = computed(() => {
  if (!props.currentCandidate.results) return null;

  const candidateStyles: LeadershipStyle = JSON.parse(props.currentCandidate.results.leadership_style.value);
  return Object.values(candidateStyles.categories).every((value) => value === 0);
});
</script>
